import { ref } from 'vue'
import { useApi } from '@/functions/api'

export function useBranchesList () {
  const api = useApi()
  const branches = ref<Branch[]>([])
  const loading = ref(false)

  const getData = async () => {
    try {
      loading.value = true
      const response = await api.GET<ApiCollection<Branch>>('warehouse/branch')
      branches.value = response.data
    } finally {
      loading.value = false
    }
  }

  return {
    getData,
    loading,
    branches,
  }
}
